(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/currency-counter/assets/javascripts/currency-counter.js') >= 0) return;  svs.modules.push('/components/lb-ui/currency-counter/assets/javascripts/currency-counter.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState;
const _svs$utils$format = svs.utils.format,
  currency = _svs$utils$format.Currency,
  currencyFromJupiterString = _svs$utils$format.CurrencyFromJupiterString;
const gsapCounterEffect = svs.components.lbUi.currencyCounter.gsapCustomEffects.gsapCounterEffect;
gsap.registerEffect({
  name: 'customCounter',
  extendTimeline: true,
  effect: gsapCounterEffect
});

const CurrencyCounter = _ref => {
  let amount = _ref.amount,
    className = _ref.className,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 2 : _ref$duration,
    uniqueId = _ref.uniqueId;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const previousAmount = useRef(amount);
  const prevUniqueId = useRef(uniqueId);
  const counterRef = useRef();
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isInitialRender = _useState2[0],
    setIsInitialRender = _useState2[1];
  const classNames = ['currency-counter'];
  className && classNames.push(className);
  useEffect(() => {
    if (uniqueId !== prevUniqueId.current) {
      previousAmount.current = amount;
      prevUniqueId.current = uniqueId;
      setIsInitialRender(true);
    }
  }, [amount, uniqueId]);
  useEffect(() => {
    if (isInitialRender) {
      setIsInitialRender(false);
      return;
    }

    const currencyValue = currencyFromJupiterString(amount);
    if (!Number.isFinite(currencyValue)) {
      previousAmount.current = 0;
    } else if (previousAmount.current !== amount && Number.isFinite(currencyValue)) {
      const timeline = gsap.timeline();
      timeline.customCounter(counterRef.current, {
        end: currencyValue,
        duration: prefersReducedMotion ? 0 : duration
      });
      previousAmount.current = amount;
      return () => {
        timeline.kill();
      };
    }
  }, [amount, duration, isInitialRender, prefersReducedMotion]);

  if (!Number.isFinite(currencyFromJupiterString(amount))) {
    return React.createElement("span", {
      className: classNames.join(' ')
    }, "-");
  }
  return React.createElement("span", {
    className: classNames.join(' '),
    ref: counterRef
  }, currency(previousAmount.current));
};
setGlobal('svs.components.lbUi.currencyCounter', {
  CurrencyCounter
});

 })(window);